module.exports = __webpack_public_path__ + "img/gj6.a10e535b.png";